// extracted by mini-css-extract-plugin
export var modalFooter = "_q9-0";